export default __webpack_public_path__ + "static/ESC_Modal_ROOMSHOT-82d61f9e4434cdfddef32c4b22105e51.png";